export const CANCEL_REQUEST = "Cancel.Request";
export const CANCEL_SUCCESS = "Cancel.Success";
export const CANCEL_FAILURE = "Cancel.Failure";
export const CANCEL_RESET = "Cancel.Reset";

export function cancelDoc(id: string, comment: string) {
  return (dispatch: any, getState: any) => {
    const { auth } = getState();
    dispatch({ type: CANCEL_REQUEST });
    return fetch(`/api/documents/${id}/cancel`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${auth.token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ comment }),
    }).then(async (response) => {
      const data = await response.json();
      if (data.status === "success") {
        dispatch({ type: CANCEL_SUCCESS, payload: data.result });
      } else {
        dispatch({ type: CANCEL_FAILURE, payload: data });
      }
    });
  };
}
